import ChallengeCard from "./ChallengeCard";
import SliderSection from "./SliderSection";
import { SwiperSlide } from "swiper/react";

const NFTs = ({ tokenList, nftSection }) => {
  const buttonsData = [{ text: "ReFi" }, { text: "Deporte" }, { text: "ONG" }, { text: "Todos" }];

  return (
    <SliderSection
      title={"Tienda NFTs"}
      sectionLabel={true}
      buttonsLabelData={buttonsData}
      refSection={nftSection}
    >
      {tokenList &&
        tokenList.map((nft, i) => (
          <SwiperSlide key={i} style={{ width: "fit-content" }}>
            <ChallengeCard {...nft} nft={true} />
          </SwiperSlide>
        ))}
    </SliderSection>
  );
};

export default NFTs;
